export const Loader = () => {
  return (
    <svg
      className="animate-spin h-8 w-8 rounded-full border-2 border-transparent border-opacity-50 loader-border"
      viewBox="0 0 24 24"
    ></svg>
  );
};
